export default {
    setsfchapterid (state, data) {//作业章节id
        state.sfchapterid = data
    },
    setszyzreleaseid (state, data) {//作业发布数据
        state.szyzreleaseid = data
    },
    setSzyzStatus (state, data) {//作业发布数据
        state.szyzStatus = data
    },
}

